var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefectResolved({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.5a6.476 6.476 0 0 0 4.706-2.019c.288-.3.735-.31 1.063-.025.3.288.31.735.025 1.063A7.983 7.983 0 0 1 8 16a8 8 0 0 1-8-8 8 8 0 0 1 15.284-3.31.75.75 0 0 1-1.366.619A6.51 6.51 0 0 0 7.973 1.5c-3.563 0-6.5 2.91-6.5 6.5s2.937 6.5 6.5 6.5H8zm.75-6.278c0 .444-.334.75-.75.75a.731.731 0 0 1-.75-.75v-3.5c0-.388.334-.75.75-.75s.75.362.75.75v3.5zM7 11c0-.553.447-1.028 1-1.028.553 0 1 .475 1 1.028a.999.999 0 1 1-2 0zm12.619-5.619c.34.34.34.897 0 1.238l-4 4a.877.877 0 0 1-1.238 0l-2-2a.877.877 0 0 1 0-1.238.877.877 0 0 1 1.238 0L15 8.762l3.381-3.38a.877.877 0 0 1 1.238 0z",
    fill: "#00664D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefectResolved);
export default __webpack_public_path__ + "static/media/defect_resolved.9579402a184a3306385d80957b676bc7.svg";
export { ForwardRef as ReactComponent };